"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Input = _interopRequireDefault(require("./Input"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _InputWithIconModule = _interopRequireDefault(require("./InputWithIcon.module.scss"));

var _excluded = ["icon", "iconPosition", "isError", "className", "inputClassName", "iconClassName", "children", "wrapperRef"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var InputWithIcon = function InputWithIcon(_ref) {
  var icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      isError = _ref.isError,
      className = _ref.className,
      inputClassName = _ref.inputClassName,
      iconClassName = _ref.iconClassName,
      children = _ref.children,
      wrapperRef = _ref.wrapperRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, _InputWithIconModule["default"].wrapper, isError && _InputWithIconModule["default"].error),
    ref: wrapperRef
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    className: (0, _classnames["default"])(inputClassName, _InputWithIconModule["default"].input, _InputWithIconModule["default"][iconPosition]),
    isError: isError
  }, props)), iconPosition && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: icon,
    className: (0, _classnames["default"])(iconClassName, _InputWithIconModule["default"].icon, _InputWithIconModule["default"][iconPosition])
  }), children);
};

process.env.NODE_ENV !== "production" ? InputWithIcon.propTypes = {
  icon: _propTypes["default"].string.isRequired,
  iconPosition: _propTypes["default"].oneOf(['left', 'right']),
  isError: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  inputClassName: _propTypes["default"].string,
  iconClassName: _propTypes["default"].string
} : void 0;
InputWithIcon.defaultProps = {
  iconPosition: undefined,
  className: '',
  inputClassName: '',
  iconClassName: ''
};
var _default = InputWithIcon;
exports["default"] = _default;